import * as reducers from './reducers';

export const constants = {
  NAME: 'accountManager',
};

export default { constants, reducers };
